/* Shared any-amount contribution logic for every tip jar on the site, plus the
   one-tap add used by the cart drawer.

   TWO THINGS THIS FILE EXISTS TO GET RIGHT:

   1. Drawer freshness.
      cart-items-component.fetchCartData() resolves but does NOT re-render the
      drawer DOM on this theme, so opening the drawer showed a stale/empty cart
      while the server cart was already correct. We request `sections` alongside
      /cart/add.js and swap the rendered HTML in BEFORE opening.

   2. Never re-render the whole header.
      layout/theme.liquid sets data-menu-style and --header-height on
      #header-component once at page load. Replacing the header section's HTML
      wiped both: the nav links vanished and header height collapsed to 0px.
      So we take ONLY the fresh <cart-icon> out of the returned header markup
      and swap that single node, leaving #header-component untouched.

   Amount handling: if an exact-price variant exists for the amount, it is added
   with quantity 1 so the cart reads "1 item". Only amounts with no matching
   variant fall back to the $1 unit variant x quantity.

   addVariant() is the same pipeline without the amount maths, for products that
   have exactly one variant and so need no picker - the album bundle offered in
   the cart drawer. Anything with a size has to go to its product page instead. */

window.RRTip = (function () {
  var CART_SECTION = 'cart-drawer-section';

  function headerSectionId() {
    var el = document.querySelector('[id^="shopify-section-"][id*="header_section"]');
    return el ? el.id.replace('shopify-section-', '') : null;
  }

  function sectionsParam() {
    var ids = [CART_SECTION];
    var h = headerSectionId();
    if (h) ids.push(h);
    return ids.join(',');
  }

  function swapCartSection(html) {
    var target = document.getElementById('shopify-section-' + CART_SECTION);
    if (!target || !html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.getElementById('shopify-section-' + CART_SECTION);
    target.innerHTML = fresh ? fresh.innerHTML : html;
  }

  function swapCartIcon(html) {
    if (!html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('cart-icon');
    var current = document.querySelector('cart-icon');
    if (fresh && current && current.parentNode) {
      current.parentNode.replaceChild(fresh, current);
    }
  }

  function openDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    return false;
  }

  function format(amount, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'USD',
        maximumFractionDigits: 0
      }).format(amount);
    } catch (e) {
      return '$' + amount;
    }
  }

  function buildItem(unitVariantId, amount, currency, variantMap) {
    var exact = variantMap && variantMap[String(amount)];
    if (exact) {
      // Exact-price variant: quantity 1, so the cart reads "1 item".
      return { id: Number(exact), quantity: 1 };
    }
    // Fallback: build the amount out of $1 units.
    return {
      id: Number(unitVariantId),
      quantity: Number(amount),
      properties: { Contribution: format(amount, currency) }
    };
  }

  /* Single add path for everything: post, swap the rendered drawer in, open it.
     Both public callers go through here so the two section-swap rules above are
     only implemented once. */
  function postAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: sectionsParam(),
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        }
        if (data && data.sections) {
          var hId = headerSectionId();
          swapCartSection(data.sections[CART_SECTION]);
          if (hId) swapCartIcon(data.sections[hId]);
        }
        return data;
      })
      .then(function (data) {
        openDrawer();
        return data;
      });
  }

  function add(unitVariantId, amount, currency, variantMap) {
    return postAdd([buildItem(unitVariantId, amount, currency, variantMap)]);
  }

  function addVariant(variantId, quantity) {
    return postAdd([{ id: Number(variantId), quantity: Number(quantity) || 1 }]);
  }

  return { add: add, addVariant: addVariant, openDrawer: openDrawer, format: format };
})();
